import useCustomer from './useCustomer.js'

export default useCustomer
